export const mmToPixels = (mm: number, dpi = 96): number => {
  return mm * (dpi / 25.4);
};